import React from "react";
import { Link } from "react-router";
import { FormattedMessage } from "react-intl";

import { MANAGER, DIRECTOR, FINANCE, FINTECH, ADMINISTRATOR } from "../../../utils/Roles";
import userHasAccess from "../../../utils/userHasAccess";

const menus = [
  {
    condition: () => userHasAccess(MANAGER),
    to: "/dashboard/admin/insurers",
    title: "admin.pages.insurers",
  },
  {
    condition: () => userHasAccess(MANAGER),
    to: "/dashboard/admin/brokers",
    title: "admin.pages.brokers",
  },
  {
    condition: () => userHasAccess(MANAGER),
    to: "/dashboard/admin/guarantees",
    title: "admin.pages.guarantees",
  },
  {
    condition: () => userHasAccess(DIRECTOR),
    to: "/dashboard/admin/users",
    title: "admin.pages.users",
  },
  {
    condition: () => userHasAccess(DIRECTOR),
    to: "/dashboard/admin/groups",
    title: "admin.pages.groups",
  },
  {
    condition: () => userHasAccess(MANAGER),
    to: "/dashboard/admin/blocs",
    title: "admin.pages.blocs",
  },
  {
    condition: () => userHasAccess([FINANCE, FINTECH, ADMINISTRATOR], true),
    to: "/dashboard/admin/accounts",
    title: "admin.accounts.title",
  },
  {
    condition: () => userHasAccess([FINANCE, FINTECH, ADMINISTRATOR], true),
    to: "/dashboard/admin/taxes",
    title: "admin.pages.taxes",
  },
];

const AdminNav = () => {
  return (
    <div className="sub-nav">
      <ul>
        {menus.map((menu, index) => {
            if (menu.condition && menu.condition() === false) {
              return false;
            }
            return (
              <li key={index}>
                <Link to={menu.to} activeClassName="active">
                  <FormattedMessage id={menu.title} />
                </Link>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default AdminNav;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/AdminNav.js